<ion-app>
  <app-mobile-menu />
  <app-header-mast (toggleMenu)="onToggleMobileMenu()" />
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-pagination-banner />
</ion-app>
